import { useState, createContext, useCallback, useEffect } from "react";

import { TContext, TState } from "./types";

const initialState: TState = {
    identityId: "",
    credentials: null,
    isLoggedIn: null,
    isGuest: null,
    isTemporaryPassword: undefined,
    isSignupComplete: undefined,
    updateCredentialsAt: undefined,
};

export const AuthContext = createContext({} as TContext);

export const AuthProvider = ({ children }: { children: any }) => {
    const [authState, setAuthState] = useState<TState>(initialState);

    const resetAuthState = useCallback(() => {
        setAuthState(initialState);
    }, []);

    const updateAuthState = useCallback((args: Partial<TState>) => {
        setAuthState((prevState) => ({
            ...prevState,
            ...args,
        }));
    }, []);

    useEffect(() => {
        console.log("[authState]", authState);
    }, [authState]);

    return (
        <AuthContext.Provider
            value={{ authState, resetAuthState, updateAuthState }}
        >
            {children}
        </AuthContext.Provider>
    );
};
